import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class JournalEntry {
  id = ""
  title = ""
  content = ""
  tags: string[] = []
  createdAt: Date | null = null
  updatedAt: Date | null = null
}

export const JOURNAL_ENTRY_DESER: SchemaDeSer<JournalEntry> =
  new SchemaDeSerBuilder(JournalEntry)
    .ofStrings("id", "title", "content")
    .ofPrimitiveArray("tags")
    .ofDateTime("createdAt")
    .ofDateTime("updatedAt")
    .toDeSer()
